import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { NumberCardComponent } from './number-card/number-card.component';
import { TitleComponent } from './title/title.component';
import { PedidosServiceService } from './services/pedidos-service.service';

@NgModule({
  declarations: [
    AppComponent,
    NumberCardComponent,
    TitleComponent
  ],
  imports: [
    BrowserModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { 

}
